import React from "react";
import ForgotPinLayer from "../components/ForgotPinLayer";

const ForgotPinPage = () => {
  return (
    <>
      {/* ForgotPinLayer */}
      <ForgotPinLayer />
    </>
  );
};

export default ForgotPinPage;
